/** Account currency (INR/USD), driven by country selected at signup. */

export const CURRENCY_BY_COUNTRY = { India: 'INR', USA: 'USD' };
export const CURRENCY_SYMBOLS = { INR: 'Rs.', USD: '$' };

export function getUserCurrency() {
  try {
    const raw = localStorage.getItem('userData');
    const d = raw ? JSON.parse(raw) : {};
    return d.currency || 'INR';
  } catch (e) {
    return 'INR';
  }
}

export function currencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency || getUserCurrency()] || CURRENCY_SYMBOLS.INR;
}

export function formatMoney(amount, currency) {
  if (amount == null || !Number.isFinite(Number(amount))) return '—';
  const cur = currency || getUserCurrency();
  const locale = cur === 'USD' ? 'en-US' : 'en-IN';
  return Number(amount).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
